import React, { useEffect } from 'react';
import { Outlet, Route, Routes } from 'react-router-dom';
import { AppRoute, AuthRoute, PermissionRoute } from './ProtectedRoutes';
import { useDispatch, useSelector } from 'react-redux';
import { login, logout, refreshUserData } from '../redux/features/authSlice';
import { CircularProgress, Backdrop, Stack } from '@mui/material';
import jwt_decode from 'jwt-decode';
import { decrypt } from '../utils/Crpyto';
import loadable from '@loadable/component';
import appapi from '../api/apiClient';
import Privacy from '../pages/Legal/Privacy';
import Terms from '../pages/Legal/Terms';
import Login from '../pages/Auth/login/Login';
import ResetConfirm from '../pages/Auth/resetConfirmPassword/ResetConfirm';
import ResetPassword from '../pages/Auth/resetPassword/ResetPassword';
import Dashboard from '../pages/Layout/Dashboard';
import CompanyManagement from '../pages/Layout/CompanyManagement/CompanyManagement';
import Trader from '../pages/Layout/Trader/Trader';
import Verifier from '../pages/Layout/Verifier/Verifier';
import Analytics from '../pages/Layout/Analytics/Analytics';
import LoadingIndicator from '../components/LoadingIndicator';
import { useState } from 'react';
import SettingsPage from '../pages/Layout/Settings/SettingsPage';
import ActivityLog from '../pages/Layout/ActivityLog/ActivityLogMain';
import ActivityLogMain from '../pages/Layout/ActivityLog/ActivityLogMain';
import { CancelToken } from 'apisauce';
// import Login from '../pages/Auth/login/Login';

//lazy Load
//Auth
// const ResetConfirm = loadable(() => import('../pages/Auth/resetConfirmPassword/ResetConfirm'));
// Dashboard
// const Dashboard = loadable(() => import('../pages/Layout/Dashboard'));

export default function RootNavigation() {
  const dispatch = useDispatch();

  const [loading, setLoading] = useState(true);

  const { userId } = useSelector((state) => state.auth);

  let source = CancelToken.source();

  useEffect(() => {
    const accessToken = localStorage.getItem('accessToken');
    if (accessToken) {
      const decoded = jwt_decode(accessToken);
      dispatch(login(decoded.sub));
      if (userId) {
        getuserdetails(decoded.sub);
      }
    } else {
      setLoading(false);
    }
    return () => {
      if (source) {
        source.cancel();
      }
    }
  }, [userId]);

  const getuserdetails = async (userId) => {
    if (userId) {
      setLoading(true);
      if (source) {
        source.cancel();
      }
      source = CancelToken.source();
      const response = await appapi.get(`/user/details`, {}, {
        cancelToken: source.token
      });
      if (response.ok) {
        const data = response.data;
        if (data.status === '7400') {
          dispatch(refreshUserData(data.response));
        }
        setLoading(false);
      } else {
        setLoading(false);
      }
    }
  };

  return loading ? (
    <Stack
      sx={{ height: '100vh' }}
      alignItems="center"
      justifyContent="center"
    >
      <CircularProgress />
    </Stack>
  ) : (
    <>
      <Routes>
        <Route
          path="/privacy"
          element={<Privacy />}
        />
        <Route
          path="/terms"
          element={<Terms />}
        />

        <Route
          path="/login"
          element={
            <AppRoute>
              <Login />
            </AppRoute>
          }
        />
        <Route
          path="/forgotPassword"
          element={
            <AppRoute>
              <ResetPassword />
            </AppRoute>
          }
        />
        <Route
          path="/resetPassword/:verificationToken"
          element={
            <AppRoute>
              <ResetConfirm />
            </AppRoute>
          }
        />
        <Route
          path="/"
          element={
            <AuthRoute>
              <Dashboard />
            </AuthRoute>
          }
        >
          <Route
            path=""
            element={
              <PermissionRoute name="Analytics">
                <Analytics />
              </PermissionRoute>
            }
          />
          <Route
            path="companyManagement"
            element={
              <PermissionRoute name="Company Management">
                <CompanyManagement />
              </PermissionRoute>
            }
          />
          <Route
            path="trader"
            element={
              <PermissionRoute name="trader">
                <Trader />
              </PermissionRoute>
            }
          />
          <Route
            path="verifier"
            element={
              <PermissionRoute name="verifier">
                <Verifier />
              </PermissionRoute>
            }
          />
          <Route
            path="activityLog"
            element={
              <PermissionRoute name="activityLog">
                <ActivityLogMain />
              </PermissionRoute>
            }
          />
          <Route
            path="settings"
            element={
              <PermissionRoute name="settings">
                <SettingsPage />
              </PermissionRoute>
            }
          />
        </Route>
      </Routes>

      <LoadingIndicator />
    </>
  );
}
